module.exports = __webpack_public_path__ + "img/kaokutoukai_kagan.22c1dfe9.png";